export const WL_QUERY_PARAMS = {
  affSub1: 'aff_sub',
  affSub2: 'aff_sub2',
  affSub3: 'aff_sub3',
  affSub4: 'aff_sub4',
  affSub5: 'aff_sub5',
  layout: 'layout',
  nonPartnerWl: 'nonPartnerWl',
  offerId: 'offer_id',
  partnerId: 'aff_id', // id партнёра в WL
  source: 'source',
  themePalette: 'themePaletteNew',
  transactionId: 'transaction_id',
  // открывать ли ссылку в режиме WL,
  // !!! используется в ингрессах без переменной не забыть менять там
  isWL: 'isWL',
  isAutosend: 'isAutosend',
  isTopXView: 'isTopXView',
  microCreditView: 'microCreditView',
  countProducts: 'countProducts',
  isUseSravniUser: 'isUseSravniUser',
  entryPoint: 'entry_point',
  externalUserId: 'external_user_id',
  productType: 'productType',
} as const;

export const IS_WL_QUERY_TRUE_STRING = `${WL_QUERY_PARAMS.isWL}=true`;

export type TQueryParamsValue = (typeof WL_QUERY_PARAMS)[keyof typeof WL_QUERY_PARAMS];
